module.exports = __webpack_public_path__ + "static/lee-917fbdc7dc8e7f003cd47da4b6d2c4fc.jpg";